import React, { Component } from 'react';

import UserModel from './UserModel';
import RoleModel from './RoleModel';

import { Form, Input, Button, Modal, Transfer } from 'antd';
const FormItem = Form.Item;

class UserForm extends Component {

  state = {
    modalVisible: false,
    transferKeys: [],
    transferTargetKeys: []
  }

  componentWillMount() {
    RoleModel.getAll()
      .then(data => {
        this.setState({
          transferKeys: data
        })
      });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }  

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        delete values.secondpassword;
        this.props.onSuccess(this.props.form, values);
        this.setState({
          transferTargetKeys: []
        });
      }
    });
  }

  renderTransferItem(item) {
    const customLabel = (
      <span className="custom-item">
        {item.title} - {item.description}
      </span>
    );

    return {
      label: customLabel, // for displayed item
      value: item.title, // for title and filter matching
    };
  }

  handleTransferChange(targetKeys, direction, moveKeys) {    
    this.props.form.setFieldsValue({
      roles: targetKeys
    });
    this.setState({ transferTargetKeys: targetKeys });
  }

  handleValidateUsername(rule, value, cb) {
    UserModel.isUsernameExist(value)
      .then(exist => {        
        if (exist) {
          cb('Uživatelské jméno již v systému existuje!');
        } else {
          cb();
        }
      })
      .catch(() => {
        cb('Uzivatel jiz existuje cb!');
      });
  }

  handleValidateSecondPassword(rule, value, cb) {
    let password = this.props.form.getFieldValue('password');

    if (password === value) {
      cb()
    } else {
      cb('Hesla se neshodují!');
    }
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const fullFormItemLayout = {
      labelCol: {
        xs: { span: 0 },
        sm: { span: 0 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit.bind(this)}>
        <FormItem
          {...formItemLayout}
          label="Celé jméno" >
          {getFieldDecorator('name', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Uživatelské jméno" >
          {getFieldDecorator('username', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }, {
              validator: this.handleValidateUsername
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Heslo" >
          {getFieldDecorator('password', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input type="password" />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Heslo ještě jednou" >
          {getFieldDecorator('secondpassword', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }, {
              validator: this.handleValidateSecondPassword.bind(this)
            }],
          })(
            <Input type="password" />
          )}
        </FormItem>
        <FormItem
          {...fullFormItemLayout}
          label="Role" >
          {getFieldDecorator('roles', {
            rules: [{
              type: 'array', message: 'Položka musí obsahovat pole rolí!',
            }, {
              required: true, message: 'Vyberte prosím alespoň jednu roli!',
            }],
          })(
            <Transfer
              dataSource={this.state.transferKeys}
              listStyle={{
                width: 350,
                height: 300,
              }}
              targetKeys={this.state.transferTargetKeys}
              onChange={this.handleTransferChange.bind(this)}
              render={this.renderTransferItem} />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={800}
          title="Vytvoření nového uživatele"
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.form.resetFields();
            this.props.onModalCancel();            
            this.setState({ modalVisible: false, transferTargetKeys: [] });
          }}
          footer={<p></p>} >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(UserForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/UserForm.js